const getBrowserClientTimeZone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return void 0;
  }
};

export { getBrowserClientTimeZone };
//# sourceMappingURL=getBrowserClientTimeZone.js.map
